import './App.scss';

import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { WpsContext, store } from './Store';

import { IdpProvider } from 'Hooks/useIdp';
import 'i18n';
import { router } from 'routes';

const App = () => {
  return (
    <Provider store={store} context={WpsContext}>
      <IdpProvider>
        <RouterProvider router={router} />
      </IdpProvider>
    </Provider>
  );
};

export default App;
